<template>
  <div class="group-page">
    <HomeCarousel 
      :carouselData="banners"
      :interval="5000"
    />
    
    <div class="group-container">
      <!-- 集团简介 -->
      <section id="intro" class="group-section" data-aos="fade-up">
        <h2>{{ $t('group.intro') }}</h2>
        <!-- 使用 v-html 渲染富文本内容 -->
        <div class="intro-content" v-html="groupInfo.profile"></div>
      </section>

      <!-- 成员企业 -->
      <section id="members" class="group-section" data-aos="fade-up">
        <h2>{{ $t('group.members') }}</h2>
        <!-- 内容 -->
        <!-- 使用 v-html 渲染富文本内容 -->
        <div class="intro-content" v-html="groupInfo.member"></div>
      </section>

      <!-- 其他模块类似 -->
      <section id="culture" class="group-section" data-aos="fade-up">
        <h2>{{ $t('group.culture') }}</h2>
        <!-- 使用 v-html 渲染富文本内容 -->
        <div class="intro-content" v-html="groupInfo.culture"></div>
      </section>

      <section id="products" class="group-section group2" data-aos="fade-up">
        <h2>{{ $t('group.products') }}</h2>
        <div class="products-container" data-aos="fade-up" data-aos-delay="200">
          <!-- 人才服务 -->
          <div class="product-item">
            <div class="product-title">
              <div class="title-line"></div>
              <h3>{{ getProductByType(1).title }}</h3>
            </div>
            <p class="product-desc">{{ getProductByType(1).description }}</p>
            <div class="product-more">
              <router-link to="/talent" :class="['more-btn', { 'more-btn-en': isEnglish } ]">{{ $t('group.viewNow') }}<img src="../../assets/home/gengduo.png" alt="right"></router-link>
            </div>
          </div>

          <!-- 企业服务 -->
          <div class="product-item">
            <div class="product-title">
              <div class="title-line"></div>
              <h3>{{ getProductByType(2).title }}</h3>
            </div>
            <p class="product-desc">{{ getProductByType(2).description }}</p>
            <div class="product-more">
              <router-link to="/enterprise/lifecycle" :class="['more-btn', { 'more-btn-en': isEnglish } ]">{{ $t('group.viewNow') }}<img src="../../assets/home/gengduo.png" alt="right"></router-link>
            </div>
          </div>

          <!-- 政府服务 -->
          <div class="product-item">
            <div class="product-title">
              <div class="title-line"></div>
              <h3>{{ getProductByType(3).title }}</h3>
            </div>
            <p class="product-desc">{{ getProductByType(3).description }}</p>
            <div class="product-more">
              <router-link to="/government/service" :class="['more-btn', { 'more-btn-en': isEnglish } ]">{{ $t('group.viewNow') }}<img src="../../assets/home/gengduo.png" alt="right"></router-link>
            </div>
          </div>
        </div>
      </section>

      <section id="history" class="group-section" data-aos="fade-up">
        <h2>{{ $t('group.history') }}</h2>
        <!-- 使用 v-html 渲染富文本内容 -->
        <div class="intro-content" v-html="groupInfo.development"></div>
      </section>

      <section id="honors" class="group-section" data-aos="fade-up">
        <h2>{{ $t('group.honors') }}</h2>
        <!-- 使用 v-html 渲染富文本内容 -->
        <div class="intro-content" v-html="groupInfo.honors"></div>
      </section>

      <section id="partners" class="group-section" data-aos="fade-up">
        <h2>{{ $t('group.partners') }}</h2>
        <!-- 使用 v-html 渲染富文本内容 -->
        <div class="intro-content" v-html="groupInfo.partners"></div>
      </section>

      <section id="contact" class="group-section" data-aos="fade-up">
        <h2>{{ $t('group.contact') }}</h2>
        <!-- 使用 v-html 渲染富文本内容 -->
        <div class="intro-content" v-html="groupInfo.contact"></div>
      </section>

      <section id="join" class="group-section joina" data-aos="fade-up" @click="joina">
        <h2>{{ $t('group.join') }}</h2>
        <!-- 使用 v-html 渲染富文本内容 -->
        <div class="intro-content" v-html="groupInfo.join"></div>
      </section>
    </div>
  </div>
</template>

<script>
import HomeCarousel from '@/components/Carousel.vue'
import { getBannerList } from '@/api/home'
import { getGroupInfo, getGroupProducts } from '@/api/group'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: 'GroupView',
  components: {
    HomeCarousel
  },
  data() {
    return {
      banners: [],
      groupInfo: {
        intro: ''  // 富文本内容
      },
      products: []
    }
  },
  computed: {
    isEnglish() {
      return this.$i18n && this.$i18n.locale === 'en'
    }
  },
  created() {
    this.getBanners()
    this.getGroupInfo()
    this.getGroupProducts()
  },
  mounted() {
    // 初始化 AOS
    AOS.init({
      duration: 1000,    // 动画持续时间
      once: true,        // 动画是否只执行一次
      offset: 100,       // 触发动画的位置
      easing: 'ease-in-out-cubic' // 动画曲线
    })
  },
  methods: {
    async getBanners() {
      try {
        const res = await getBannerList()
        this.banners = res.data.filter(item => item.type === 2)
      } catch (error) {
        console.error('获取轮播图数据失败:', error)
      }
    },
    async getGroupInfo() {
      try {
        const res = await getGroupInfo()
        this.groupInfo = res.data
      } catch (error) {
        console.error('获取集团信息失败:', error)
      }
    },
    async getGroupProducts() {
      try {
        const res = await getGroupProducts()
        this.products = res.data
      } catch (error) {
        console.error('获取集团产品失败:', error)
      }
    },
    getProductByType(type) {
      return this.products.find(product => product.type === type) || { title: '', description: '' }
    },
    // 修改加入我们点击之后的boss链接
    joina() {
      window.open('https://www.zhipin.com/web/geek/job?query=%E6%B1%9F%E8%8B%8F%E8%8B%8F%E6%B6%A6%E4%BA%BA%E6%89%8D%E5%8F%91%E5%B1%95%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&city=101190100')
    }
  }
}
</script>

<style scoped>
.group-page {
  min-height: 100vh;
  background: #F6F7F9;
}

.group-container {
  /* max-width: 1200px; */
  margin: 0 auto;
  padding-top: 40px;
  background: #FFFFFF;
  padding-bottom: 40px;
}

.group-section {
  padding: 60px 0;
  scroll-margin-top: 100px;
  max-width: 1200px;
  margin: 0 auto;
  max-height: 900px;
  overflow: hidden;
}

.group2 {
  height: auto !important;
}

.group-intro {
  /* background: url('../../assets/group/qiyejianjiebeijing.png') no-repeat center center; */
  /* background-size: 100% 100%; */
  max-height: 900px;
  overflow: hidden;
  padding:0 360px ;
}

.group-section h2 {
  font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 30px;
color: #484848;
line-height: 42px;
font-style: normal;
}

.group-intro h2 {
  font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 30px;
color: #484848;
line-height: 42px;
font-style: normal;
}

/* 富文本内容样式 */
.intro-content {
  padding-top: 80px;
  color: #484848;
}

/* 由于使用了 v-html，需要使用 deep 选择器来修改富文本中的样式 */
.intro-content :deep(p) {
  margin-bottom: 16px;
  line-height: 1.8;
  font-size: 16px;
}

.intro-content :deep(img) {
  max-width: 100%;
  height: auto;
  margin: 20px 0;
}

.intro-content :deep(h1),
.intro-content :deep(h2),
.intro-content :deep(h3),
.intro-content :deep(h4),
.intro-content :deep(h5),
.intro-content :deep(h6) {
  margin: 20px 0;
  font-weight: bold;
}

.intro-content :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.intro-content :deep(th),
.intro-content :deep(td) {
  border: 1px solid #ddd;
  padding: 8px;
}

.intro-content :deep(ul),
.intro-content :deep(ol) {
  padding-left: 20px;
  margin: 16px 0;
}

.intro-content :deep(li) {
  margin-bottom: 8px;
}

.products-container {
  display: flex;
  gap: 24px;
  margin-top: 60px;
}

.product-item {
  flex: 1;
  padding: 20px 10px 10px 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 180px;
  background: #FFFFFF;
box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.1);
border-radius: 8px;
  transition: all 0.3s ease-in-out;
}

.product-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.joina {
  cursor: pointer;
}

.product-title {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 15px;
}

.title-line {
  width: 4px;
  height: 20px;
  background: #3379F2;
border-radius: 3px;
}

.product-title h3 {
  font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 24px;
color: #484848;
line-height: 33px;
text-align: left;
font-style: normal;
}



.product-desc {
  font-family: PingFangSC, PingFang SC;
  margin-bottom: 20px;
  flex-grow: 1;
font-weight: 400;
font-size: 14px;
color: #302929;
line-height: 20px;
text-align: left;
font-style: normal;
height: 40px;
display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

}

.product-more {
  display: flex;
  justify-content: flex-end;
}

.more-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  transition: all 0.3s ease-in-out;
  background: linear-gradient(270deg, #FFFFFF 0%, #E4EAFF 100%);
  border-radius: 23px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #3379F2;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  width: 122px;
  white-space: nowrap;
}

.more-btn-en {
  min-width: 146px;
  width: auto;
}

.more-btn:hover {
  transform: translateY(-2px);
}

.more-btn img {
  width: 16px;
  height: 16px;
  display: block;
  border-radius: 50%;
  background: #3379F2;
}


.more-btn:hover {
  background: #3379F2;
  color: #FFFFFF;
}

/* .more-btn:hover img {
  filter: brightness(0) invert(1);
} */

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .products-container {
    gap: 20px;
  }

  /* .product-item {
    padding: 30px;
  } */

  .group-container {
    padding: 0% 5%;
  }
}

@media screen and (max-width: 768px) {
  .products-container {
    flex-direction: column;
  }

  .product-item {
    min-height: auto;
  }

  .product-desc {
    margin-bottom: 30px;
  }
}
</style> 